import { staticImplements } from '@/decorators/staticImplements';
import { EventRepositoryInterface } from '@/api/interfaces/event/eventRepositoryInterface';
import { httpClient } from '../httpClient/httpClient';

import { GetEventsResponse } from '@/api/interfaces/event/getEventsResponse';
@staticImplements<EventRepositoryInterface>()
export class EventRepository {
    static async getEvents(applicationId: string): Promise<GetEventsResponse> {
        const response = await httpClient.get<GetEventsResponse>(
            `/api/dea/v1/application/${applicationId}/events`,
        );
        return response;
    }
}
